module.exports = __webpack_public_path__ + "public/files/img/rate.438807f8.png";